import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useSelector } from 'react-redux';
import CheckoutForm from './CheckoutForm';
import Loader from '../loader/Loader';

// const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);

function Checkout() {
  const userPaymentDetails = useSelector((state) => state.payment.userPaymentDetails);
  const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`, {
    stripeAccount: userPaymentDetails?.stripe_user_id,
  });

  const klarnaPaymentHandler = async () => {
    const stripe = await stripePromise;
    const clientSecret = userPaymentDetails?.client_secret;

    // const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
    //   payment_method: {
    //     billing_details: {
    //       email: userPaymentDetails?.email,
    //       address: {
    //         country: 'IT', // Klarna requires supported country codes (e.g., DE for Germany)
    //       },
    //     },
    //   },
    //   return_url: `${process.env.REACT_APP_BASE_URL}pay/verify-page`, // Replace with your actual return URL
    //   // return_url: 'http://localhost:3000/pay/verify-page', // Replace with your actual return URLl
    // });

    /*
    Stipe Manual Payment Method for Klarna and Scalapay
    */
    const { error } = await stripe.confirmPayment({
      clientSecret,
      confirmParams: {
        payment_method_data: {
          // Passing the payment method type to the stripe confirm payment method
          // type: 'scalapay', // Set to 'klarna' for Klarna payments
          type: userPaymentDetails?.installment_pay_method, // Set to 'klarna' for Klarna payments
          billing_details: {
            email: userPaymentDetails?.email,
            address: {
              country: 'IT',
            },
          },
        },
        // Return URL where the customer should be redirected after the authorization
        return_url: `${process.env.REACT_APP_BASE_URL}pay/verify-page`,
      },
    });

    if (error) {
      console.error(error);
      // Handle error, e.g., show error message to the user
    }
  };
  if (userPaymentDetails?.payment_type === 'installment') {
    klarnaPaymentHandler();
  }
  const oneTimeOptions = {
    mode: 'payment',
    // eslint-disable-next-line no-unsafe-optional-chaining
    amount: userPaymentDetails?.amount * 100,
    currency: 'eur',
    payment_method_types: ['card'],
    paymentMethodCreation: 'manual',
    // customer: stripeCustomerId, // Add customer ID here
  };
  const subscriptionOptions = {
    mode: 'payment',
    // eslint-disable-next-line no-unsafe-optional-chaining
    amount: userPaymentDetails?.amount * 100,
    currency: 'eur',
    payment_method_types: ['card'],
    paymentMethodCreation: 'manual',
    setup_future_usage: 'off_session',
  };
  const installmentOptions = {
    mode: 'payment',
    // eslint-disable-next-line no-unsafe-optional-chaining
    amount: userPaymentDetails?.amount * 100,
    currency: 'eur',
    payment_method_types: ['card'],
    paymentMethodCreation: 'manual',
    // setup_future_usage: 'off_session',
  };

  let options;

  switch (userPaymentDetails?.payment_type) {
    case 'installment':
      options = installmentOptions;
      break;
    case 'subscription':
      options = subscriptionOptions;
      break;
    case 'one_time':
    default:
      options = oneTimeOptions;
      break;
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      {userPaymentDetails?.payment_type === 'installment' ? (
        <>
          <Loader />
        </>
      ) : (
        <CheckoutForm />
      )}
    </Elements>
  );
}

export default Checkout;
